"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getGoogleMapValues = getGoogleMapValues;
exports.getLocationDisplayAddress = getLocationDisplayAddress;
exports.getLocationHeadersForProvider = getLocationHeadersForProvider;
exports.getLocationPhoneNumber = getLocationPhoneNumber;
exports.getSortedLocations = getSortedLocations;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _globals = require("./constants/globals");
/**
 * Method to determine what headers are needed for location data.
 * @param {object[]} locations The location data for a provider to create headers for.
 * @return {object} An object with headers as keys set to true values if encountered.
 */
function getLocationHeadersForProvider(locations) {
  const headers = {};
  for (const header of _globals.ALL_LOCATION_HEADERS) {
    if ((0, _some.default)(locations).call(locations, location => {
      return !!location[header] || header === 'phone' && getLocationPhoneNumber(location);
    })) {
      headers[header] = true;
    }
  }
  return headers;
}

/**
 * Sort locations by rank, distance, and then name.
 * @param {object[]} locations The locations to sort
 * @return {object[]} The sorted location array
 */
function getSortedLocations(locations) {
  return (0, _sortBy.default)(locations, ['rank', 'distance', 'name']);
}

/**
 * Gets a displayable address string for a location
 * @param {object} location The location to get the display address for.
 * @return {string} Display friendly address string
 */
function getLocationDisplayAddress(location) {
  const street2 = location.street2 ? location.street2 + ', ' : '';
  const suite = location.suite ? location.suite + ', ' : '';
  return `${location.street1}, ${street2}${suite}${location.city}, ${location.state} ${location.zip}`;
}

/**
 * Get the proper phone number for a location if possible
 * @param {object} location The location to get the phone number for.
 * @return {string || null} The proper phone number if found, null if not.
 */
function getLocationPhoneNumber(location) {
  if (location.contacts && location.contacts.length) {
    for (const contact of location.contacts) {
      if (contact.type === 'PMC Phone') {
        return contact.value;
      }
    }
  }
  return location.phone || null;
}

/**
 * Get a google map or direction link
 * @param {object} location The location to get the google maps link for.
 * @param {string || undefined} searchedLocation The location user may have searched to find Providers around.
 * @return {object} An object containg the google maps link and the location string used to get it.
 */
function getGoogleMapValues(location, searchedLocation) {
  const baseMapUrl = 'https://www.google.com/maps';

  // Create URI component
  let locationUriComponent = _globals.MAP_LOCATION_FIELDS;
  locationUriComponent = (0, _map.default)(locationUriComponent).call(locationUriComponent, field => location[field]);
  locationUriComponent = (0, _filter.default)(locationUriComponent).call(locationUriComponent, field => !!field);
  locationUriComponent = locationUriComponent.join(' ');
  const locationURI = encodeURIComponent(locationUriComponent);
  let mapHref;
  if (searchedLocation) {
    mapHref = `${baseMapUrl}/dir/${encodeURIComponent(searchedLocation)}/${locationURI}/`;
  } else {
    mapHref = `${baseMapUrl}/place/${locationURI}/`;
  }
  return {
    href: mapHref,
    locationString: locationUriComponent
  };
}